const afterSubmitActions = Object.freeze({
  None: 'none',
  reParseCurrent: 'reParseCurrent',
  reParseLast50: 'reParseLast50',
});

export default afterSubmitActions;
